import router from "../../router";

import promotionsService from "@/services/promotionsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      const res = await promotionsService.create(formData);
      dispatch(
        "common/showSuccess",
        `Angebot #${res.data.id} wurde erfolgreich angelegt.`,
        { root: true }
      );
      router.push({ name: "CMSPromotionEdit", params: { id: res.data.id } });
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebot konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }) {
    try {
      const res = await promotionsService.findAll();
      commit("setAll", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebote konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findOne({ commit, dispatch }, { id }) {
    commit("setSingle", null);
    try {
      const res = await promotionsService.findOne({ id });
      commit("setSingle", res.data);
      return Promise.resolve({...res.data});
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebot konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await promotionsService.delete({ id });
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebot konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      const res = await promotionsService.update(formData);
      // dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Angebot wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebot konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  }
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
